import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getCouponById } from "../services/adminApi";

import CouponAnalytics from "../components/coupons/CouponAnalytics";
import CouponPreview from "../components/coupons/CouponPreview";

import "../styles/CouponDetails.css";
import "../styles/CouponAnalytics.css";
import "../styles/CouponPreview.css";

const CouponDetails = () => {
    const { id } = useParams();

    const [coupon, setCoupon] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadCoupon();
        // eslint-disable-next-line
    }, []);

    const loadCoupon = async () => {
        try {
            const res = await getCouponById(id);
            setCoupon(res.data.coupon);
        } catch (err) {
            console.error("Failed to load coupon", err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <p>Loading coupon details...</p>;
    }

    if (!coupon) {
        return <p>Coupon not found.</p>;
    }

    return (
        <div className="coupon-details-page">

            <h2>{coupon.title}</h2>

            <div className="coupon-details-card">

                <table className="coupon-details-table">
                    <tbody>

                        <tr>
                            <td>Coupon Code</td>
                            <td>{coupon.code}</td>
                        </tr>

                        <tr>
                            <td>Description</td>
                            <td>{coupon.description}</td>
                        </tr>

                        <tr>
                            <td>Discount Type</td>
                            <td>{coupon.discountType}</td>
                        </tr>

                        <tr>
                            <td>Discount Value</td>
                            <td>{coupon.discountValue}</td>
                        </tr>

                        <tr>
                            <td>Maximum Discount</td>
                            <td>₹{coupon.maxDiscount}</td>
                        </tr>

                        <tr>
                            <td>Minimum Order</td>
                            <td>₹{coupon.minOrderAmount}</td>
                        </tr>

                        <tr>
                            <td>Usage Limit</td>
                            <td>{coupon.usageLimit}</td>
                        </tr>

                        <tr>
                            <td>Used Count</td>
                            <td>{coupon.usedCount}</td>
                        </tr>

                        <tr>
                            <td>Status</td>
                            <td>{coupon.status}</td>
                        </tr>

                        <tr>
                            <td>Customer Type</td>
                            <td>{coupon.customerType}</td>
                        </tr>

                        <tr>
                            <td>First Order Only</td>
                            <td>{coupon.firstOrderOnly ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <td>Auto Apply</td>
                            <td>{coupon.autoApply ? "Yes" : "No"}</td>
                        </tr>

                        <tr>
                            <td>Valid From</td>
                            <td>
                                {new Date(coupon.validFrom).toLocaleString()}
                            </td>
                        </tr>

                        <tr>
                            <td>Valid Until</td>
                            <td>
                                {new Date(coupon.validUntil).toLocaleString()}
                            </td>
                        </tr>

                    </tbody>
                </table>

            </div>

            {/* Analytics */}
            <CouponAnalytics coupon={coupon} />

            {/* Coupon Preview */}
            <CouponPreview coupon={coupon} />

        </div>
    );
};

export default CouponDetails;